module.exports = __webpack_public_path__ + "static/media/Group.7133b4ed.svg";